import { Grid } from '@mui/material';
import React from 'react';
import { PointValueToAdd } from '../types';
import { UnderlineTextInput } from 'library';

export function AddPointValue({
    pointValueToAdd,
    setPointValueToAdd,
}: {
    pointValueToAdd: PointValueToAdd;
    setPointValueToAdd: (p: PointValueToAdd) => void;
}) {
    function updatePointValueToAdd(value: number | string, key: keyof PointValueToAdd) {
        setPointValueToAdd({ ...pointValueToAdd, [key]: value });
    }
    return (
        <Grid item container flexDirection="column">
            <UnderlineTextInput
                value={pointValueToAdd.name}
                helperText={"Internal Name (i.e. 'NO_SHOW')"}
                onChange={(e) => updatePointValueToAdd(e.target.value, 'name')}
            />
            <UnderlineTextInput
                value={pointValueToAdd.description}
                helperText={"External Name (i.e. 'No Show')"}
                onChange={(e) => updatePointValueToAdd(e.target.value, 'description')}
            />
            <UnderlineTextInput
                value={pointValueToAdd.value}
                helperText={"Points to add/subtract (i.e. '-10 or 10')"}
                onChange={(e) => updatePointValueToAdd(e.target.value, 'value')}
                type="number"
            />
        </Grid>
    );
}
